"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.collate = collate;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _interleave = require("../$interleave/interleave");

function* byComparison({
  comparator
}, canTakeAny, ...buffers) {
  let candidateBuffer;

  while (candidateBuffer = canTakeAny()) {
    let candidateItem = candidateBuffer.peek();

    for (const buffer of buffers) {
      const item = buffer.peek();

      if (buffer.canTake() && comparator(candidateItem, item) < 0) {
        candidateItem = item;
        candidateBuffer = buffer;
      }
    }

    yield candidateBuffer.take();
  }
}

function collate(sources, comparator) {
  return (0, _interleave.interleave)(sources, byComparison, {
    comparator
  });
}

var _default = (0, _iterable.iterableCurry)(collate, {
  variadic: true
});

exports.default = _default;